import { useUrlOverlay, type UrlOverlay } from "@/lib/useUrlOverlay";
import {
  PREVIEW_MARK,
  PREVIEW_PARAM,
  readPreviewPanel,
} from "@/lib/submissions/previewPanel";

const PREVIEW: UrlOverlay = {
  param: PREVIEW_PARAM,
  read: (params) => (readPreviewPanel(params) ? "1" : null),
  mark: PREVIEW_MARK,
};

/** Whether Preview submission is open, from the URL (BRK-S357), by any URL
 *  overlay's rules (`useUrlOverlay`). */
export function usePreviewPanel() {
  const { value, open, close } = useUrlOverlay(PREVIEW);
  return { open: value !== null, show: () => open("1"), close };
}
